import { asyncAction } from 'lib/actionCreators'

export const parsedResumesList = asyncAction('recruiter/PARSED_RESUMES_LIST')
export const newParsedResumesList = asyncAction('recruiter/NEW_PARSED_RESUMES_LIST')
